/* ADD Knowledge categories */
export const ADD_SUPPORT_MATERIAL_TYPE = "ADD_SUPPORT_MATERIAL_TYPE"
export const ADD_SUPPORT_MATERIAL_TYPE_SUCCESS =
  "ADD_SUPPORT_MATERIAL_TYPE_SUCCESS"
export const ADD_SUPPORT_MATERIAL_TYPE_CLEAN = "ADD_SUPPORT_MATERIAL_TYPE_CLEAN"
export const ADD_SUPPORT_MATERIAL_TYPE_ERROR = "ADD_SUPPORT_MATERIAL_TYPE_ERROR"
